import type { RouterLocale } from '~shared/constants/i18n';

export function getRandomInt(min = 10000000, max = 50000000) {
	min = Math.ceil(min);
	max = Math.floor(max);
	return Math.floor(Math.random() * (max - min + 1) + min);
}

export function isNumber(v: string | number | undefined) {
	const n = Number(v);
	return v !== '' && typeof n === 'number' && !isNaN(n) && isFinite(n);
}

export const abbreviateNumber = (number: number) => {
	const units = ['', 'K', 'M', 'B', 'T'];
	let unitIndex = 0;

	while (number >= 1000 && unitIndex < units.length - 1) {
		number /= 1000;
		unitIndex++;
	}

	return `${Math.floor(number * 10) / 10}${units[unitIndex]}`;
};

export const formatPriceWithCurrency = (
	price: number,
	locale: RouterLocale,
	currency = 'USD',
	short?: boolean
) => {
	return new Intl.NumberFormat(locale, {
		style: 'currency',
		currency,
		currencyDisplay: 'narrowSymbol',
		...(short && { minimumFractionDigits: 0, maximumFractionDigits: 1 }),
	}).format(price);
};
